export default "__VITE_ASSET__853b87a5__"